<div class="popup-div w-full justify-center flex-col items-center">
  <div class="flex justify-between items-center pb-3">
    <div class="flex gap-4 items-center">
      <div class="yellow-bar"></div>
      <h1 class="sub-text text-center">{{activity_id?'Update':'Add'}} Category</h1>
    </div>
    <img
      src="../../../assets/Icons/close-icon.svg"
      class="close-icon"
      (click)="close()"
      style="cursor: pointer"
    />
  </div>
  <form
    class="w-full flex flex-col gap-4 mb-6"
    [formGroup]="activity_form"
  >
    <div class="flex-column">
      <h2 class="sidebar-text">
        <span class="error-validation-text" style="font-size: 22px !important"
          >*</span
        >Name
      </h2>
    </div>
    <div class="inputForm">
      <input
        type="text"
        class="input"
        placeholder="Enter the category name"
        name="name"
        style="width: 90% !important"
        formControlName="name"
        [ngClass]="{ 'form-input-error': f.name.errors && submited }"
      />
    </div>
  </form>
  <button
    class="button-submit flex justify-center items-center"
    (click)="submit(activity_form?.value)"
  >
    <span *ngIf="!button_loader">{{activity_id?'Update':'Add'}}</span>
    <mat-spinner
      class="button-loader"
      *ngIf="button_loader"
      diameter="20"
    ></mat-spinner>
  </button>
</div>
